import { TCreateAlertRuleFields } from 'shared/types'
import { api } from '..'

export const editAlertRuleInfo =
  (alertRuleId: string) => (data: TCreateAlertRuleFields) =>
    api.put(`/v1/alert-rules/${alertRuleId}/information`, data)
